import React, { Component } from 'react';
import { connect } from 'react-redux';
import withRouter from '../../../lib/router/withRouter';
import { message } from 'antd';
import { Form } from '@ant-design/compatible';
import { filter, findIndex, includes, sortBy } from 'lodash';
import {
  MAXIMUM_NUMBER_OF_RECOMMEND_STORE_ITEM_COUNT,
  MINIMUM_NUMBER_OF_RECOMMEND_STORE_ITEM_COUNT,
} from '../../../constants/service/app/recommendStoreConstants';
import { NO_DATA_ON_EXCEL_DOWNLOAD_WARNING_TEXT } from '../../../constants/service/common/utilConstants';
import { asyncSimpleModal } from '../../../lib/common';
import { recommendStoreActions } from '../../../store/modules/recommend/store';
import RecommendStoreSaveWrap from '../../../views/recommend/store/save/RecommendStoreSaveWrap';

class RecommendStoreSaveContainer extends Component {
  /**
   *  추천 브랜드 복사하기
   */
  onSubmit = () => {
    const { form, recommendStoreSave, createRecommendStore } = this.props;
    const { recommendStoreInfo, recommendStoreItemList } = recommendStoreSave;

    form.validateFieldsAndScroll((err) => {
      console.log(err);
      if (err) return;

      /**
       *  추천 브랜드 아이템 최소 개수 체크드
       */
      if (recommendStoreItemList.selectedItemList.list.length < MINIMUM_NUMBER_OF_RECOMMEND_STORE_ITEM_COUNT) {
        message.error(`추천 브랜드 아이템은 최소 ${MINIMUM_NUMBER_OF_RECOMMEND_STORE_ITEM_COUNT}개이상입니다.`);
        return;
      }

      createRecommendStore({
        /**
         *  추천 브랜드 정보
         */
        recommendStoreInfo: {
          /**
           *  추천 브랜드 타입
           */
          type: recommendStoreInfo.type,
          /**
           *  메모
           */
          memo: recommendStoreInfo.memo,
        },
        /**
         *  추천 상품 후기에 연결된 브랜드 id 리스트
         */
        recommendStoreItemList: recommendStoreItemList.selectedItemList.list.map((item) => ({
          id: item.id,
          subText: item.subText,
        })),
      });
    });
  };

  /**
   *  추천 상품 후기에 연결할 아이템 리스트 불러오기
   */
  getRecommendStoreItemList = (option) => {
    const { getRecommendStoreItemList, recommendStoreSave } = this.props;
    const { recommendStoreItemList } = recommendStoreSave;
    const { filterOption, sortOption, pagination } = recommendStoreItemList.itemList;

    getRecommendStoreItemList({
      filterOption,
      sortOption,
      pagination,
      ...option,
    });
  };

  /**
   *  추천 상품 후기에 연결할 아이템 선택하기
   */
  selectRecommendStoreItemList = async (action, moveIdList) => {
    const { setData, recommendStoreSave } = this.props;
    const { recommendStoreItemList } = recommendStoreSave;
    const { itemList, selectedItemList } = recommendStoreItemList;

    /**
     *  업데이트 될 선택된 연결할 아이템 리스트
     */
    let updatedSelectRecommendStoreItemList = [];

    /**
     *  연결할 아이템 아이템 추가
     */
    if (action === 'add') {
      let targetList = filter(itemList.list, (item) => includes(moveIdList, item.id));

      /**
       *  이전에 선택되어 있던 아이템 리스트와
       *  추가로 선택된 아이템을 합침
       */
      updatedSelectRecommendStoreItemList = [...targetList, ...selectedItemList.list];

      /**
       *  추가하려고 하는 아이템 개수가 초과되었을 경우
       */
      if (updatedSelectRecommendStoreItemList.length > MAXIMUM_NUMBER_OF_RECOMMEND_STORE_ITEM_COUNT) {
        await asyncSimpleModal({
          type: 'error',
          title: '아이템 개수 초과',
          message: `추천 브랜드 아이템 개수는 최대 ${MAXIMUM_NUMBER_OF_RECOMMEND_STORE_ITEM_COUNT} 입니다.`,
        });
        return;
      }
    } else if (action === 'remove') {
      /**
       *  연결할 아이템 아이템 해제
       */
      /**
       *  이전에 선택되어 있던 아이템 리스트에서
       *  해제한 아이템을 빼버림
       */
      console.log(moveIdList);
      updatedSelectRecommendStoreItemList = filter(selectedItemList.list, (item) => !includes(moveIdList, item.id));
    }

    /**
     *  선택되어진 선택된 아이템은
     *  선택할 수 없도록 함
     */
    const updatedRecommendStoreItemList = itemList.list.map((item) => ({
      ...item,
      uncheckable: includes(moveIdList, item.id) ? action === 'add' : item.uncheckable,
    }));

    setData({
      path: ['recommendStoreSave', 'recommendStoreItemList', 'itemList', 'list'],
      value: updatedRecommendStoreItemList,
    });

    console.log(updatedSelectRecommendStoreItemList);
    /**
     *  선택된 아이템 업데이트하기
     */
    setData({
      path: ['recommendStoreSave', 'recommendStoreItemList', 'selectedItemList'],
      value: {
        list: updatedSelectRecommendStoreItemList,
        idList: updatedSelectRecommendStoreItemList.map((item) => item.id),
      },
    });
  };

  /**
   *  추천 브랜드 리스트 아이템 순서 변경하기
   */
  onDragEndSelectRecommendStoreItemList = async (newList) => {
    const { setData, recommendStoreSave } = this.props;
    const { recommendStoreItemList } = recommendStoreSave;
    const { selectedItemList } = recommendStoreItemList;

    const updatedSelectRecommendStoreItemList = sortBy(selectedItemList.list, (item) =>
      findIndex(newList, (_item) => _item.id === item.id),
    );

    await setData({
      path: ['recommendStoreSave', 'recommendStoreItemList', 'selectedItemList'],
      value: {
        list: updatedSelectRecommendStoreItemList,
        idList: updatedSelectRecommendStoreItemList.map((item) => item.id),
      },
    });
  };

  /**
   *  전체 브랜드 리스트 EXCEL 다운로드
   */
  getRecommendStoreItemListExcelDownload = () => {
    const { getRecommendStoreItemListExcelDownload, recommendStoreSave } = this.props;
    const { recommendStoreItemList } = recommendStoreSave;
    const { filterOption } = recommendStoreItemList.itemList;

    getRecommendStoreItemListExcelDownload({
      filterOption,
    });
  };

  /**
   *  선택된 브랜드 리스트 EXCEL 다운로드
   */
  getSelectedRecommendStoreItemListExcelDownload = () => {
    const { getSelectedRecommendStoreItemListExcelDownload, recommendStoreSave } = this.props;
    const { recommendStoreInfo, recommendStoreItemList } = recommendStoreSave;
    const { list } = recommendStoreItemList.selectedItemList;

    if (!list.length) {
      message.error(NO_DATA_ON_EXCEL_DOWNLOAD_WARNING_TEXT);
      return;
    }

    getSelectedRecommendStoreItemListExcelDownload({
      recommendStoreType: recommendStoreInfo.type,
      selectedRecommendStoreItemList: list.map((item) => ({ id: item.id, subText: item.subText })),
    });
  };

  /**
   *  브랜드 리스트 EXCEL 업로드
   */
  setRecommendStoreItemListExcelUpload = (file) => {
    const { form, setRecommendStoreItemListExcelUpload } = this.props;

    setRecommendStoreItemListExcelUpload({
      form,
      attachment: [file],
    });
  };

  render() {
    const { form, recommendStoreSave, setData, typeDisabled } = this.props;

    return (
      <RecommendStoreSaveWrap
        form={form}
        setData={setData}
        recommendStoreSave={recommendStoreSave}
        typeDisabled={typeDisabled}
        getRecommendStoreItemList={this.getRecommendStoreItemList}
        selectRecommendStoreItemList={this.selectRecommendStoreItemList}
        onSubmit={this.onSubmit}
        onDragEndSelectRecommendStoreItemList={this.onDragEndSelectRecommendStoreItemList}
        getRecommendStoreItemListExcelDownload={this.getRecommendStoreItemListExcelDownload}
        getSelectedRecommendStoreItemListExcelDownload={this.getSelectedRecommendStoreItemListExcelDownload}
        setRecommendStoreItemListExcelUpload={this.setRecommendStoreItemListExcelUpload}
      />
    );
  }
}

const mapStateToProps = (state) => {
  return {
    recommendStoreSave: state.recommendStore.recommendStoreSave,
  };
};

const mapDispatchToProps = {
  setData: recommendStoreActions.setData,
  getRecommendStoreItemList: recommendStoreActions.getRecommendStoreItemList,
  createRecommendStore: recommendStoreActions.createRecommendStore,
  getRecommendStoreItemListExcelDownload: recommendStoreActions.getRecommendStoreItemListExcelDownload,
  getSelectedRecommendStoreItemListExcelDownload: recommendStoreActions.getSelectedRecommendStoreItemListExcelDownload,
  setRecommendStoreItemListExcelUpload: recommendStoreActions.setRecommendStoreItemListExcelUpload,
};

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(Form.create()(RecommendStoreSaveContainer)));
